import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  fetchHasDistributionDeals,
  fetchDistributionDeals,
  IFetchDistributionDealsResponse, IFetchHasDistributionDealsResponse
} from './deals.thunk';
import { IDistributionDeal } from './interfaces';
import { DISTRIBUTION_DEALS_TABLE_INITIAL_PAGE } from '../../../../components/credits/consts';

interface IDistributionDealState {
  loading: boolean;
  list: IDistributionDeal[];
  totalDocs: number;
  page: number;
  hasDeals: boolean;
  hasDealsLoading: boolean;
}

export const initialState: IDistributionDealState = {
  loading: false,
  list: [],
  totalDocs: 0,
  page: DISTRIBUTION_DEALS_TABLE_INITIAL_PAGE,
  hasDeals: false,
  hasDealsLoading: false
};

const dealsSlice = createSlice({
  name: 'deals',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchDistributionDeals.pending, (state: IDistributionDealState) => {
      state.loading = true;
      state.list = [];
      state.totalDocs = 0;
      state.page = 1;
    });
    builder.addCase(fetchDistributionDeals.fulfilled, (state: IDistributionDealState, action: PayloadAction<IFetchDistributionDealsResponse>) => {
      const { page, totalDocs, docs = [] } = action.payload;
      state.loading = false;
      state.list = [...docs];
      state.totalDocs = totalDocs;
      state.page = page;
    });
    builder.addCase(fetchDistributionDeals.rejected, (state: IDistributionDealState) => {
      state.loading = false;
    });
    builder.addCase(fetchHasDistributionDeals.pending, (state: IDistributionDealState) => {
      state.hasDealsLoading = true;
    });
    builder.addCase(fetchHasDistributionDeals.fulfilled, (state: IDistributionDealState, action: PayloadAction<IFetchHasDistributionDealsResponse>) => {
      const { exists } = action.payload;
      state.hasDealsLoading = false;
      state.hasDeals = exists;
    });
    builder.addCase(fetchHasDistributionDeals.rejected, (state: IDistributionDealState) => {
      state.hasDealsLoading = false;
    });
  }
});

export const dealsActions = {
  ...dealsSlice.actions
};

export const dealsReducer = dealsSlice.reducer;
